// VerticalMenu.js
import React from 'react';

const VerticalMenu = () => {
    return (
        <div className="vertical-menu">
            <a href="#Processing Report" className="menu-item">Processing Report</a>

        </div>
    );
};

export default VerticalMenu;
